<template>
  <component :is="href ? 'a' : 'span'" class="fa-stack fa-xs flex-shrink-0" :href="href" :target="href ? '_target' : null">
    <i class="fa-stack-2x" :class="icon1" />
    <i class="fa-stack-1x" :class="icon2" />
  </component>
</template>

<script>
  export default {
    name: 'UiIconStack',
    props: {
      href: {
        type: String,
      },
      icon1: {
        type: String,
        default: 'fa fa-square fa-stack-2x text-gray-800',
      },
      icon2: {
        type: String,
      },
    },
  }
</script>
